import React from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";
import SteminpeLeaderboardTopPlayStudent from "../../components/leaderboards/SteminpeLeaderboardTopPlayStudent";

export default function SteamTopPlayStudentLeaderboard() {

    const { orgId, skillCode } = useParams();

    // Get query parameters if needed
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Get the orgType query parameter if needed, default is all
    const orgType = queryParams.get('org_type') || 'all';

    // For example, if you want to get a "filter" query parameter:
    // const filter = queryParams.get('filter');

    return (
        <Box>
            <SteminpeLeaderboardTopPlayStudent
                orgId={orgId}
                skillCode={skillCode}
                orgType={orgType} />
        </Box>
    );
}